import { createAction } from 'redux-actions';

export const userDocumentCreate = createAction('USER_DASHBOARD_USER_DOCUMENT_CREATE');
export const userDocumentCreateSuccess = createAction('USER_DASHBOARD_USER_DOCUMENT_CREATE_SUCCESS');
export const userDocumentCreateError = createAction('USER_DASHBOARD_USER_DOCUMENT_CREATE_ERROR');
